/* ============================================================
   Diego Kong MX — Home Hero v3 "KONG DAILY" · vanilla JS, no deps
   · The index ("En esta edición") drives the slides; the wholesale price counts up on each new story.
   · The track is a native scroll-snap container: swipe works even if this file fails.
   · This adds arrows/dots/autoplay on top and keeps them in sync with the scroll position.
   · Autoplay pauses on hover, focus, touch, hidden tab and when the hero is off-screen,
     and resumes where it left off (the progress bar and the timer stay in step).
   · Shopify editor events (block:select / section:load / section:unload) supported.
   ============================================================ */
(function () {
  'use strict';
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');

  function initHero(root) {
    if (!root || root.dataset.hhsInit === '1') return;
    root.dataset.hhsInit = '1';

    var track = root.querySelector('[data-hhs-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.hhs__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hhs-go]'));
    var prev = root.querySelector('.hhs__arrow--prev');
    var next = root.querySelector('.hhs__arrow--next');
    var counter = root.querySelector('[data-hhs-cur]');
    var total = slides.length;
    if (!track || total === 0) return;

    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !REDUCE && total > 1;
    var current = -1, timer = null, remaining = interval, startedAt = 0;
    var holds = {};                       /* reasons autoplay is on hold: hover, focus, touch, hidden, offscreen, editor */
    if (autoplay) root.classList.add('hhs--auto');

    function setActive(i) {
      if (i === current) return;
      current = i;
      slides.forEach(function (s, j) { var on = j === i; s.classList.toggle('is-active', on); s.inert = !on; });
      dots.forEach(function (d, j) {
        d.classList.toggle('is-active', j === i);
        d.classList.toggle('is-done', j < i);
        d.setAttribute('aria-selected', j === i ? 'true' : 'false');
      });
      if (counter) counter.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      var tab = dots[i], list = tab && tab.parentElement;                              /* keep the active tab visible when the index scrolls */
      if (list && list.scrollWidth > list.clientWidth) list.scrollTo({ left: tab.offsetLeft - list.offsetLeft - 16, behavior: REDUCE ? 'auto' : 'smooth' });
      if (root.classList.contains('is-played')) countUp(slides[i]);
      remaining = interval;
      schedule();
    }

    /* count-up of the wholesale price (#78); the HTML already holds the final number */
    function countUp(slide) {
      var el = slide.querySelector('[data-hhs-count]');
      if (!el || REDUCE) return;
      if (!el.hasAttribute('data-hhs-final')) el.setAttribute('data-hhs-final', el.textContent);   /* server-rendered value, captured once */
      var to = parseFloat(el.getAttribute('data-hhs-count')), final = el.getAttribute('data-hhs-final'), t0 = performance.now(), D = 700;
      var run = (el._hhsRun || 0) + 1; el._hhsRun = run;                                              /* a newer run cancels an older one */
      if (!(to > 0)) return;
      var fmt = final.replace(/[0-9][0-9.,]*/, '#');
      (function step(t) {
        if (el._hhsRun !== run) return;
        var k = Math.min(Math.max((t - t0) / D, 0), 1), e = 1 - Math.pow(1 - k, 3);
        el.textContent = k < 1 ? fmt.replace('#', Math.round(to * (0.55 + 0.45 * e)).toLocaleString('es-MX')) : final;
        if (el._hhsRun !== run) return;
        if (k < 1) requestAnimationFrame(step); else el.textContent = final;
      })(t0);
      setTimeout(function () { if (el._hhsRun === run) el.textContent = final; }, D + 100);   /* never leave a half-counted price */
    }

    function go(i) {
      i = (i + total) % total;
      root.classList.add('is-played');
      track.scrollTo({ left: i * track.clientWidth, behavior: REDUCE ? 'auto' : 'smooth' });
      setActive(i);
    }

    /* keep state in sync with swipes / trackpad scrolls */
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (i !== current && i >= 0 && i < total) { root.classList.add('is-played'); setActive(i); }
      });
    }, { passive: true });

    /* ---------- autoplay with pause/resume that remembers the elapsed time ---------- */
    function onHold() { for (var k in holds) if (holds[k]) return true; return false; }
    function clear() { if (timer) { clearTimeout(timer); timer = null; } }
    function schedule() {
      clear();
      if (!autoplay || onHold()) return;
      startedAt = performance.now();
      timer = setTimeout(function () { go(current + 1); }, remaining);
    }
    function hold(reason, on) {
      var was = onHold();
      holds[reason] = on;
      var now = onHold();
      if (!was && now && timer) { remaining = Math.max(remaining - (performance.now() - startedAt), 200); clear(); }
      root.classList.toggle('is-paused', now);
      if (was && !now) schedule();
    }

    if (next) next.addEventListener('click', function () { go(current + 1); });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    root.addEventListener('keydown', function (e) {
      if (e.target.closest('a, input')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    });

    root.addEventListener('mouseenter', function () { hold('hover', true); root.classList.add('is-hover'); });
    root.addEventListener('mouseleave', function () { hold('hover', false); root.classList.remove('is-hover'); });
    root.addEventListener('focusin', function () { hold('focus', true); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) hold('focus', false); });
    track.addEventListener('touchstart', function () { hold('touch', true); }, { passive: true });
    track.addEventListener('touchend', function () { hold('touch', false); }, { passive: true });
    document.addEventListener('visibilitychange', function () { hold('hidden', document.hidden); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { hold('offscreen', !entries[0].isIntersecting); }, { threshold: 0.25 }).observe(root);
    }

    /* keep the right slide in view after a resize/rotation */
    window.addEventListener('resize', function () { track.scrollTo({ left: current * track.clientWidth, behavior: 'auto' }); }, { passive: true });

    /* ---------- tilt (#61) + cursor-reactive grid (#57): precise pointers only ---------- */
    if (FINE.matches && !REDUCE) {
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = 0, frame = null, rect = null;
      var loop = function () {
        cx += (tx - cx) * 0.12; cy += (ty - cy) * 0.12;
        if (frame) frame.style.transform = 'rotateX(' + cy.toFixed(2) + 'deg) rotateY(' + cx.toFixed(2) + 'deg)';
        if (Math.abs(tx - cx) > 0.02 || Math.abs(ty - cy) > 0.02) { raf = requestAnimationFrame(loop); return; }
        raf = 0;
        if (frame && tx === 0 && ty === 0) { frame.style.transform = ''; frame.classList.remove('is-tilting'); frame = null; }
      };
      root.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var scene = e.target.closest('[data-hhs-tilt]');
        if (!scene) { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(loop); return; }
        var f = scene.querySelector('.hhs__frame');
        if (f !== frame) { if (frame) frame.style.transform = ''; frame = f; rect = scene.getBoundingClientRect(); frame.classList.add('is-tilting'); }
        tx = ((e.clientX - rect.left) / rect.width - 0.5) * 7;
        ty = -((e.clientY - rect.top) / rect.height - 0.5) * 7;
        if (!raf) raf = requestAnimationFrame(loop);
      }, { passive: true });
      root.addEventListener('mouseleave', function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(loop); });
    }

    /* ---------- shared-element hand-off to the next page (#15) ---------- */
    root.addEventListener('click', function (e) {
      var cta = e.target.closest('[data-hhs-cta]');
      if (!cta || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var img = slides[current].querySelector('.hhs__img');
      if (img) img.style.viewTransitionName = 'kong-hero';
      try { sessionStorage.setItem('kh-vt', '1'); } catch (_) {}
    });
    window.addEventListener('pageshow', function () {       /* back/forward cache: drop the name again */
      slides.forEach(function (s) { var img = s.querySelector('.hhs__img'); if (img) img.style.viewTransitionName = ''; });
    });

    /* ---------- Shopify editor ---------- */
    root.addEventListener('shopify:block:select', function (e) {
      var idx = slides.indexOf(e.target.closest('.hhs__slide'));
      if (idx >= 0) { hold('editor', true); go(idx); }
    });
    root.addEventListener('shopify:block:deselect', function () { hold('editor', false); });

    root._hhsStop = clear;
    setActive(0);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-hhs]');
    for (var i = 0; i < roots.length; i++) initHero(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-hhs]');
    if (root) { root.dataset.hhsInit = ''; initHero(root); }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-hhs]');
    if (root && root._hhsStop) root._hhsStop();
  });
}());

/* Contador "viendo ahora" del slide de mayoreo: oscila suave dentro de [min, max], más bajo de noche (hora de México). */
(function () {
  'use strict';
  var els = document.querySelectorAll('[data-hhs-live]');
  if (!els.length) return;
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function mxHour() {
    try { return parseInt(new Intl.DateTimeFormat('es-MX', { hour: 'numeric', hour12: false, timeZone: 'America/Mexico_City' }).format(new Date()), 10); }
    catch (e) { return new Date().getHours(); }
  }
  function factor() {
    var h = mxHour();
    if (h >= 1 && h < 7) return 0.86;      /* madrugada */
    if (h >= 7 && h < 11) return 0.93;
    if (h >= 18 && h < 23) return 1;        /* pico */
    return 0.97;
  }
  Array.prototype.forEach.call(els, function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 280;
    var max = parseInt(el.getAttribute('data-max'), 10) || 340;
    if (max <= min) max = min + 40;
    var f = factor();
    var lo = Math.round(min * f), hi = Math.round(max * f);
    var m = new Date().getMinutes();                                   /* arranque estable: no salta al recargar */
    var val = lo + Math.round((hi - lo) * (0.5 + 0.35 * Math.sin(m / 9.5)));
    el.textContent = val;
    if (REDUCE) return;
    (function tick() {
      setTimeout(function () {
        if (!document.hidden) {
          var step = Math.ceil(Math.random() * 3) * (Math.random() < 0.5 ? -1 : 1);
          if (val + step > hi || val + step < lo) step = -step;
          val += step;
          el.textContent = val;
          el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick');
        }
        tick();
      }, 2600 + Math.random() * 3400);
    })();
  });
}());
